import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import InstituteTemplate from "../../Components/InstituteTemplate/InstituteTemplate";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import DesktopTabsForLeanerAndInstructor from "./DesktopTabsForLeanerAndInstructor/DesktopTabsForLeanerAndInstructor";
import LearnersSchedule from "./LearnerSchedule/LearnerSchedule";
import { GetLocalStorage } from "../../Helpers/LocalStorage/LocalStorage";
import { GetInstituteAllStudentsScheduleA } from "../../Actions/StudentA";

const LearnerAndInstructorScheduleChild= () => {
    const Dispatch = useDispatch();
       
    const [activeTab, setActiveTab] = useState("LearnerSchedule");
    const InstituteId = GetLocalStorage("UserInfo")?.Institute?.InstituteId;
    console.log("InstituteId is:",InstituteId)

    const { loading, InstituteAllStudentsSchedule } = useSelector(
        (Store) => Store.StudentReducer
      );
      console.log("InstituteAllStudentsSchedule is:",InstituteAllStudentsSchedule)

      useEffect(() => {
        if (InstituteId) {
            Dispatch(GetInstituteAllStudentsScheduleA(InstituteId)); 
        }
      }, [Dispatch, InstituteId]); // Add `userId` if it's used in the effect
     // Function to render the right-side content based on the active tab
    const renderContent = () => {
         switch (activeTab) {
            case "LearnerSchedule":
                return <LearnersSchedule InstituteAllStudentsSchedule={InstituteAllStudentsSchedule} />;
            default:
                return <LearnersSchedule />;
         }
     };
    
    return (
        <>
         {!loading ? (
              <>
                <DesktopTabsForLeanerAndInstructor setActiveTab={setActiveTab} activeTab={activeTab} />
                <div className="pb-[100px] bg-[#FFFFFF]">
                    {renderContent()}
                </div>
              </>
         ) :  (
              <LoadingSpinner
              Height="[500px]"
              Width="[99%]"
              Top="[80px]"
              Left="0"
              Position="relative"
            />
         )}
        </>
    );
};


const LearnerAndInstructorSchedules = () => (
    <InstituteTemplate
      Element={LearnerAndInstructorScheduleChild}
      m_top="mt-0"
      bg="bg-[#F0F0F7]"
    />
  );

export default LearnerAndInstructorSchedules;
